import dayjs from 'dayjs';
import 'dayjs/locale/bg';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/tr';
import 'dayjs/locale/pt';
import 'dayjs/locale/el';
import 'dayjs/locale/ro';
import 'dayjs/locale/sr';
import 'dayjs/locale/hu';
import { Languages } from '../../types';

interface IDateFormatter {
  date: Date;
  locale?: Languages;
}

export const formatDate = ({ date, locale = 'en' }: IDateFormatter): string => {
  dayjs.locale(locale);
  return dayjs(date).format('D MMM');
};
